import {
    AfterViewInit,
    Component,
    ElementRef, EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnInit, Output,
    Renderer2,
    SimpleChange,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'upsc-dual-range-slider',
    templateUrl: './dual-range-slider.component.html',
    styleUrls: ['./dual-range-slider.component.scss'],
})
export class DualRangeSliderComponent implements OnInit, OnChanges, AfterViewInit {
    /**
     * Minimum value of the slider.
     */
    @Input() public min = 0;

    /**
     * Maximum value of the slider.
     */
    @Input() public max = 100;

    /**
     * The label on the minimum side of the slider.
     */
    @Input() public minLabel = `$0`;

    /**
     * The label on the maximum side of the slider.
     */
    @Input() public maxLabel = `$100000`;

    /**
     * The lower value of the slider (first thumb).
     */
    @Input() public minValue = 0;

    /**
     * The higher value of the slider (second thumb).
     */
    @Input() public maxValue = 100;

    @Output() public minValueChanged = new EventEmitter<number>();
    @Output() public maxValueChanged = new EventEmitter<number>();

    @HostBinding('class') public hostClass = 'dual-range-slider';

    @ViewChild('minInput') minInput: ElementRef;
    @ViewChild('maxInput') maxInput: ElementRef;

    public formGroup: UntypedFormGroup;

    constructor(private formBuilder: UntypedFormBuilder,
                private renderer: Renderer2,
    ) {
        this.formGroup = this.formBuilder.group({
            minValue: [20],
            maxValue: [80],
        });
    }

    public ngOnInit() {
        this.formGroup.get('minValue').valueChanges.subscribe((value) => {
            const maxValueControl = this.formGroup.get('maxValue');
            // if (maxValueControl?.value < value) {
            //     maxValueControl.setValue(value, { emitEvent: false });
            // }

            this.updateRangeGradient();
            this.minValueChanged.emit(value);
            this.maxValueChanged.emit(maxValueControl.value);
        });

        this.formGroup.get('maxValue').valueChanges.subscribe((value) => {
            const minValueControl = this.formGroup.get('minValue');
            // if (value < minValueControl?.value) {
            //     minValueControl.setValue(value, { emitEvent: false });
            // }

            this.updateRangeGradient();
            this.minValueChanged.emit(minValueControl.value);
            this.maxValueChanged.emit(value);
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.onMinValueChanged(changes.minValue);
        this.onMaxValueChanged(changes.maxValue);
    }

    public ngAfterViewInit(): void {
        this.updateRangeGradient();
    }

    private onMinValueChanged(change: SimpleChange): void {
        if (change === null || change === undefined) {
            return;
        }

        this.formGroup.get('minValue').setValue(change?.currentValue);
    }

    private onMaxValueChanged(change: SimpleChange): void {
        if (change === null || change === undefined) {
            return;
        }

        this.formGroup.get('maxValue').setValue(change?.currentValue);
    }

    private updateRangeGradient() {
        const minValue = this.formGroup.get('minValue').value;
        const maxValue = this.formGroup.get('maxValue').value;

        const minPercent = (minValue - this.min) * 100 / this.max;
        const maxPercent = (maxValue - this.min) * 100 / this.max;

        const inactiveColor = '#C6C6C6';
        const activeColor = '#0A8080';
        const gradientStyle = `linear-gradient(to right, ${ inactiveColor } ${ minPercent }%, ${ activeColor } ${ minPercent }%, ${ activeColor } ${ maxPercent }%, ${ inactiveColor } ${ maxPercent }%)`;
        this.renderer.setStyle(this.minInput.nativeElement, 'background', gradientStyle);
        this.renderer.setStyle(this.maxInput.nativeElement, 'background', gradientStyle);
    }
}
